import { Button } from '@mui/material'

import { Maybe, UserConnectionFragment } from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { MyProfileEditForm, Props } from './MyProfileEditForm'

export * from './fragments'

export type State = {
  userProfileUpdating: boolean
  avatarUploading: boolean
  user: Maybe<UserConnectionFragment>
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmitMyProfile: Props['onSubmitMyProfile']
  onClickAvatar: Props['onClickAvatar']
}

export const MyProfileEditTemplate: Template<State, Action> = ({
  state: { user, userProfileUpdating, avatarUploading },
  onSubmitMyProfile,
  onClickAvatar,
}) => {
  const { t } = useTranslation('myProfileEdit')
  const { routerNames, routerPages } = useRouter()

  return (
    <BaseLayout
      margin
      header={{
        title: t('title'),
        back: true,
        defaultBackPage: routerPages.MyProfile,
        type: 'modal',
        right: (
          <Button
            form="my-profile-edit-form"
            loading={userProfileUpdating || avatarUploading}
            type="submit"
            variant="contained"
            color="primary"
            sx={{ height: 28, whiteSpace: 'nowrap' }}
          >
            {t('submit')}
          </Button>
        ),
      }}
    >
      <Head title={routerNames.MyProfileEdit} />
      <MyProfileEditForm
        user={user ?? null}
        onSubmitMyProfile={onSubmitMyProfile}
        onClickAvatar={onClickAvatar}
      />
    </BaseLayout>
  )
}
